import { Box, Flex, ToastId, ToastProps, useToast, UseToastOptions } from '@chakra-ui/react';
import { useRef } from 'react';
import { ToastErrorIcon } from '../icons/toast-error-icon';
import { ToastSuccessIcon } from '../icons/toast-success-icon';

interface ToastOptions extends Omit<ToastProps, 'status' | 'title' | 'description'> {
  status: 'success' | 'error';
  description: string;
  title?: string;
}

interface CustomToastProps {
  status: ToastOptions['status'];
  description: string;
  title?: string;
  onClose: () => void;
}

const CustomToast = ({ status, description, title, onClose }: CustomToastProps) => (
  <Flex bgColor='rgba(0,0,0,.7)' borderRadius='xl' shadow='2xl' p='md' align='center' color='white' onClick={onClose}>
    <Box me='md'>{status === 'success' ? <ToastSuccessIcon /> : <ToastErrorIcon />}</Box>
    <Box>
      <Box fontWeight='bold' fontSize='lg'>
        {title}
      </Box>
      <Box fontSize='sm'>{description}</Box>
    </Box>
  </Flex>
);

export const useCustomToast = () => {
  const toast = useToast();
  const toastIdRef = useRef<ToastId>();

  const closeToast = () => {
    if (toastIdRef.current) toast.close(toastIdRef.current);
  };

  return ({ status, description, title, ...rest }: ToastOptions) => {
    const defaultTitle = status === 'success' ? 'Success !' : 'Oops !';

    toastIdRef.current = toast({
      duration: 3000,
      isClosable: true,
      position: 'top-right',
      render: () => (
        <CustomToast description={description} title={title ?? defaultTitle} status={status} onClose={closeToast} />
      ),
      ...(rest as UseToastOptions),
    });
  };
};
